import { render, staticRenderFns } from "./Fideicomisos_v1.vue?vue&type=template&id=463c619f"
import script from "./Fideicomisos_v1.vue?vue&type=script&lang=js"
export * from "./Fideicomisos_v1.vue?vue&type=script&lang=js"
import style0 from "./Fideicomisos_v1.vue?vue&type=style&index=0&id=463c619f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports